/*
 * Hide Klaviyo form VLtJdT only (expired Summer Sale popup and any teaser
 * that carries the same form id). The Klaviyo embed stays enabled.
 * Other forms are left alone, including future campaigns.
 */
(function () {
  'use strict';

  var EXPIRED_FORM_ID = 'VLtJdT';

  function hideExpiredKlaviyoUi() {
    var nodes = document.querySelectorAll(
      '[data-testid*="' + EXPIRED_FORM_ID + '"], [id*="' + EXPIRED_FORM_ID + '"], [class*="' + EXPIRED_FORM_ID + '"]'
    );
    if (!nodes.length) return;

    nodes.forEach(function (element) {
      var current = element;
      var container = element;
      var depth = 0;

      while (current && current !== document.body && depth < 12) {
        var className = typeof current.className === 'string' ? current.className : '';
        var role = current.getAttribute('role');
        var position = window.getComputedStyle(current).position;

        if (
          position === 'fixed' ||
          role === 'dialog' ||
          className.indexOf('kl-teaser') !== -1
        ) {
          container = current;
        }

        current = current.parentElement;
        depth += 1;
      }

      if (container.contains(document.activeElement)) {
        document.activeElement.blur();
      }

      container.setAttribute('aria-hidden', 'true');
      container.setAttribute('inert', '');
      container.style.setProperty('display', 'none', 'important');
    });
  }

  function heroBlocksFloatingVideo() {
    var hero = document.querySelector('body.template--index .bbsh');
    if (!hero) return false;
    var rect = hero.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function syncFloatingVideoHold() {
    document.documentElement.classList.toggle('bb-reeview-hold', heroBlocksFloatingVideo());
  }

  function start() {
    syncFloatingVideoHold();
    window.addEventListener('scroll', syncFloatingVideoHold, { passive: true });
    window.addEventListener('resize', syncFloatingVideoHold);

    if ('IntersectionObserver' in window) {
      var hero = document.querySelector('body.template--index .bbsh');
      if (hero) {
        new IntersectionObserver(syncFloatingVideoHold).observe(hero);
      }
    }

    hideExpiredKlaviyoUi();

    var observer = new MutationObserver(hideExpiredKlaviyoUi);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('scroll', hideExpiredKlaviyoUi, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
